// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-79cac850]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.edit-input[data-v-79cac850] {\n  padding-right: 100px;\n}\n[data-v-79cac850] .el-dialog__body {\n  padding: 15px 20px;\n}", ""]);
// Exports
module.exports = exports;
